export default "__VITE_ASSET__BL4h8x0P__"